import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fromStore, modalsSelector } from "../../selectors";
import { withRouter  } from 'react-router-dom';

import { setActiveModalAction } from "../../action";
import { useOnClickOutside } from "../../hooks";
import { addRaw, fetchProductCategories, updateRaw } from "../../action/raw";
import cn from 'classnames';
import Select from 'react-select';
import ErrorContainer from "../../components/utils/ErrorContainer";
import { isEmpty } from "lodash";
import { MEASURES_RAW } from "../rawmaterials/constansts";
import { parseNumToFixed } from "../../utils/common";

const colourStyles = {
    control: (styles) => ({ ...styles, border: "1px solid #e2e5ec" }),
};

const SelectCategories = ({ type, selected, onChange, disabled, onMenuOpen }) => {
    const dispatch = useDispatch();
    const categories = useSelector(fromStore.categoriesRawByType(type));
  
    const onChangeSelect = (value) => {
      onChange(value.id);
    };
  
    const selectedCategory = categories && selected ? categories.find((item) => item.id === selected) : null;
  
    useEffect(() => {
      isEmpty(categories) && dispatch(fetchProductCategories(type));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);
  
    return (
      <div className="form-group">
          <label htmlFor="g-category" className="form-control-label">Категория *</label>
          <Select
              id="g-category"
              value={selectedCategory}
              options={categories}
              getOptionLabel={(item) => `${item.title}`}
              getOptionValue={(item) => item.id}
              onChange={onChangeSelect}
              isClearable={false}
              placeholder="Выберите категорию..."
              noOptionsMessage={() => 'Нет категорий'}
              isDisabled={disabled}
              isLoading={disabled}
              styles={colourStyles}
              onMenuOpen={onMenuOpen}
          />
      </div>
    );
  }

function RawModal({ history }) {
    const ref = useRef();
    const modalRef = useRef(null);
    const dispatch = useDispatch();
    const id = useSelector(modalsSelector).modalRaw.id;
    const type = useSelector(modalsSelector).modalRaw.type;
    const loading = useSelector(fromStore.loaderRawSelector);
    const loadingUpdate = useSelector(fromStore.loaderUpdateRawSelector);
    const raw = useSelector(fromStore.rawById(id));

    const loader = loading || loadingUpdate;

    const measureOptions = Object.entries(MEASURES_RAW).map(([value, label]) => ({ value, label }));
    const initData = raw ? {
        name: raw.name,
        weight: raw.weight,
        measure: raw.measure,
        minBalance: raw.minBalance,
        productscategory: raw.productscategory.id,
        last_price: raw.last_price,
    } : {
        name: '',
        weight: null,
        measure: null,
        minBalance: null,
        productscategory: null,
        last_price: null,
    };
    const [data, setData] = useState(initData);
    const selectedMeasure = { value: data.measure, label: MEASURES_RAW[data.measure] };
    const isEditMode = id !== 'new';

    const onChangeInput = (field) => (e) => {
        const updated = {...data};
        updated[field] = e.target.value;
        setData(updated);
    };
    
    const onChangeNumberInput = (field, fix = 2) => (e) => {
    const updated = {...data};
        if(e.target.value.match(/^([0-9]{1,})?(\.)?([0-9]{1,})?$/)) {
            updated[field] = parseNumToFixed(e.target.value, fix);
            setData(updated);
        }
    };

    const onClose = () => !loader && dispatch(setActiveModalAction({ field: 'modalRaw', value: null }));
    useOnClickOutside(ref, onClose);

    const onSubmit = async (e) => {
        e.preventDefault();
        const rq = { ...data };
        if (rq.weight || rq.weight === '0') {
          rq.weight = parseFloat(rq.weight);
        }
        if (rq.minBalance || rq.minBalance === '0') {
            rq.minBalance = parseFloat(rq.minBalance);
        }
        if (!isEditMode) {
          const result = await dispatch(addRaw(rq));
          if (result) {
            onClose();
            history.push(`/accounting/${type === 'raw' ? 'rawmaterial' : 'semimanufactures'}/${result}`);
          }
        } else {
          const result = await dispatch(updateRaw(id, rq));
          if (result) onClose();
        }
      };
    
    const onChangeSelect = (field) => (value) => {
        const updated = {...data};
        if (field === 'measure') {
          updated[field] = value.value;
        } else {
          updated[field] = value;
        }
        setData(updated);
    }

    const isValid = () => {
    const { name, weight, measure, last_price, minBalance, productscategory } = data;

    if (type === 'raw') {
      if (isEditMode) {
        if (name || productscategory || last_price || measure || minBalance) return true;
      }
      if (name && productscategory && last_price && measure && minBalance) return true;
    } else {
      if (isEditMode) {
        if (name || productscategory || measure || weight) return true;
      }
      if (name && productscategory && measure && weight) return true;
    }

    return false;
    }

    const renderTitle = () => {
      if (isEditMode) {
        if (type === 'raw') return 'Редактирование сырья';
        return 'Редактирование полуфабриката';
      } else {
        if (type === 'raw') return 'Добавление сырья';
        return 'Добавление полуфабриката';
      }
    }

    const renderTitleSaveButton = () => {
      if (isEditMode) return 'Сохранить';
      if (type === 'raw') return 'Добавить сырье';
      return 'Добавить полуфабрикат';
    }

    const scrollToBottom = () => {
      setTimeout(() => {
        if (modalRef.current) modalRef.current.scrollTop = modalRef.current.scrollHeight;
      }, 0);
    };

    const renderBody = () => {
      if (type === 'raw') {
        return(
          <>
          <div className='row'>
            {window.innerWidth > 510 && 
            <>
              <div className='col-3'>
                <div className="form-group">
                  <label className="form-control-label">Цена *</label>
                  <input disabled={loader} type='number' value={parseNumToFixed(data.last_price)} className="form-control" onChange={onChangeNumberInput('last_price')} />
                </div>
              </div>
              <div className='col-3'>
                <div className="form-group">
                  <label className="form-control-label">Единица измерения *</label>
                  <Select
                    value={selectedMeasure}
                    options={measureOptions}
                    onChange={onChangeSelect('measure')}
                    isClearable={false}
                    placeholder="Выберите единицу..."
                    disabled={loader}
                    styles={colourStyles}
                  />
                </div>
              </div>
              <div className='col-3'>
                <div className="form-group">
                  <label className="form-control-label">Минимальный остаток *</label>
                  <input disabled={loader} type="number" value={parseNumToFixed(data.minBalance, 3)} className="form-control" onChange={onChangeNumberInput('minBalance', 3)} />
                </div>
              </div>
            </>
            }
          </div>
          {window.innerWidth <= 510 &&
          <>
          <div className='row'>
            <div className='col-3' style={window.innerWidth <= 510 ? {flex: '0 0 50%', maxWidth: '50%'} : {}}>
              <div className="form-group">
                <label className="form-control-label">Цена *</label>
                <input disabled={loader} type='number' value={parseNumToFixed(data.last_price)} className="form-control" onChange={onChangeNumberInput('last_price')} />
              </div>
            </div>
              <div className='col-3' style={window.innerWidth <= 510 ? {flex: '0 0 50%', maxWidth: '50%'} : {}}>
                <div className="form-group">
                  <label className="form-control-label">Единица измерения *</label>
                  <Select
                    value={selectedMeasure}
                    options={measureOptions}
                    onChange={onChangeSelect('measure')}
                    isClearable={false}
                    placeholder="Выберите единицу..."
                    disabled={loader}
                    styles={colourStyles}
                  />
                </div>
              </div>
          </div>
          <div className='row'>
            <div className='col-3' style={window.innerWidth <= 510 ? {flex: '0 0 50%', maxWidth: '50%'} : {}}>
              <div className="form-group">
                <label className="form-control-label">Минимальный остаток *</label>
                <input disabled={loader} type="number" value={parseNumToFixed(data.minBalance, 3)} className="form-control" onChange={onChangeNumberInput('minBalance', 3)} />
              </div>
            </div>
          </div>
          </>
          }
          </>
        );
      } else {
        return(
          <>
          <div className='row'>
            {window.innerWidth > 510 && 
            <>
              <div className='col-3'>
                <div className="form-group">
                  <label className="form-control-label">Вес/объем *</label>
                  <input disabled={loader} value={parseNumToFixed(data.weight, 3)} className="form-control" onChange={onChangeNumberInput('weight', 3)} />
                </div>
              </div>
              <div className='col-3'>
                <div className="form-group">
                  <label className="form-control-label">Единица измерения *</label>
                  <Select
                    value={selectedMeasure}
                    options={measureOptions}
                    onChange={onChangeSelect('measure')}
                    isClearable={false}
                    placeholder="Выберите единицу..."
                    disabled={loader}
                    styles={colourStyles}
                  />
                </div>
              </div>
            </>
            }
          </div>
          {window.innerWidth <= 510 &&
          <div className='row'>
            <div className='col-3' style={window.innerWidth <= 510 ? {flex: '0 0 50%', maxWidth: '50%'} : {}}>
              <div className="form-group">
                <label className="form-control-label">Вес/объем *</label>
                <input disabled={loader} value={parseNumToFixed(data.weight, 3)} className="form-control" onChange={onChangeNumberInput('weight', 3)} />
              </div>
            </div>
              <div className='col-3' style={window.innerWidth <= 510 ? {flex: '0 0 50%', maxWidth: '50%'} : {}}>
                <div className="form-group">
                  <label className="form-control-label">Единица измерения *</label>
                  <Select
                    value={selectedMeasure}
                    options={measureOptions}
                    onChange={onChangeSelect('measure')}
                    isClearable={false}
                    placeholder="Выберите единицу..."
                    disabled={loader}
                    styles={colourStyles}
                  />
                </div>
              </div>
          </div>
          }
          </>
        );
      }
    }

    return (
        <form onSubmit={onSubmit}>
          <div  className="modal fade show" style={{ display: 'block' }}>
            <div className="modal-dialog modal-lg modal-dialog-scrollable" style={{ height: '90%', alignItems: 'center', justifyContent: 'center' }}>
              <div ref={ref} className="modal-content" style={{ height: '80%' }}>
                <div className="modal-header">
                  <h5 className="modal-title"> {renderTitle()} </h5>
                  <button onClick={onClose} type="button" className="close">
                  </button>
                </div>
                <div ref={modalRef} className="modal-body">
                    <div className="form-group">
                      <label htmlFor="g-name" className="form-control-label">Название *</label>
                      <input disabled={loader} type="text" value={data.name} className="form-control" id="g-name" onChange={onChangeInput('name')} />
                    </div>
                    {renderBody()}
                    <SelectCategories disabled={loader} type={type} selected={data.productscategory} onChange={onChangeSelect('productscategory')} onMenuOpen={scrollToBottom}/>
                    <ErrorContainer field="modalRaw" hasCloseButton={true}/>
                </div>
    
                <div className="modal-footer">
                  <button disabled={loader} type="button" className="btn btn-secondary" onClick={onClose}>Отмена</button>
                  <button
                    type="submit"
                    disabled={!isValid() || loader}
                    className={cn({ 'btn btn-primary  kt-spinner--right kt-spinner--sm kt-spinner--light': true, 'kt-spinner': loader })}>
                    {renderTitleSaveButton()}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      );
}

export default withRouter(RawModal);